import { combineReducers } from 'redux-immutable';
import appReducer from './Containers/App/reducer';
import adminReducer from './Containers/Admin/reducer';
import basicRegistrationReducer from './Containers/BasicRegistration/reducer';
import billCreditsReducer from './Containers/BillCredits/reducer';
import billPaymentsReducer from './Containers/BillPayments/reducer';
import deliveryReducer from './Containers/Deliveries/reducer';
import loginReducer from './Containers/Login/reducer';
import publicFilesReducer from './Containers/PublicFiles/reducer';
import socialMediaReducer from './Containers/SocialMedia/slice';
import vendorApplicationReducer from './Containers/VendorApplication/reducer';
import vendorTeamMemberReducer from './Containers/TeamMembers/reducer';
import vendorBillsReducer from './Containers/VendorBills/reducer';
import vendorAttributesReducer from './Containers/VendorAttribution/reducer';
import complianceReducer from './Containers/Compliance/reducer';

import userReducer from './Containers/User/slice';
import factoryReducer from './Containers/Factory/slice';

export default combineReducers({
  adminReducer,
  appReducer,
  basicRegistrationReducer,
  billCreditsReducer,
  billPaymentsReducer,
  deliveryReducer,
  loginReducer,
  publicFilesReducer,
  vendorApplicationReducer,
  vendorTeamMemberReducer,
  vendorAttributesReducer,
  vendorBillsReducer,
  userReducer,
  socialMediaReducer,
  complianceReducer,
  factoryReducer,
});
